import { setAuthHeader } from "@/apis/client";
import { TOKEN_KEY, USER_KEY } from "@/constants";
import { useUserContext } from "@/context/UserContext";
import { IUserLoginResponse } from "@/modules/User/user.interface";
import { useCallback } from "react";

/**
 * Stores a fresh session after sign-in or sign-up.
 * localStorage is written before setUser because UserProvider reads USER_KEY on render.
 */
export default function usePersistSession() {
  const { setUser, setToken } = useUserContext();

  return useCallback(
    (res: IUserLoginResponse) => {
      window.localStorage.setItem(TOKEN_KEY, res.token);
      window.localStorage.setItem(USER_KEY, JSON.stringify(res.user));
      setAuthHeader(res.token);
      setUser(res.user);
      setToken(res.token);
    },
    [setUser, setToken]
  );
}
